import React, { useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";

const TicketStatusUpdate = ({
  ticketId,
  ticket,
  assetList,
  statusList,
  resolutionList,
  getAuthHeader,
  onUpdated,
}) => {
  const [form, setForm] = useState({
    asset_id: ticket.asset_id ?? "",
    status_id: ticket.ticket_status ?? "",
    resolution_id: ticket.resolution_id ?? "",
    remarks: ticket.ticket_remarks ?? "",
  });

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const submit = async (e) => {
    e.preventDefault();

    try {
      await axios.post(
        `${API_BASE_URL}/tickets/${ticketId}/update-status`,
        {
          asset_id: Number(form.asset_id),
          status_id: Number(form.status_id),
          resolution_id: Number(form.resolution_id),
          remarks: form.remarks,
        },
        { headers: getAuthHeader() }
      );

      toast.success("Status updated successfully!");
      if (onUpdated) onUpdated();
    } catch (err) {
      const res = err.response?.data;

      if (res?.errors) {
        Object.values(res.errors).forEach((m) => toast.error(m[0]));
        return;
      }

      toast.error(res?.message || "Failed to update status");
    }
  };

  return (
    <div className="card p-1">
      <ToastContainer position="bottom-right" />

      <h5 className="mb-3">Update Status</h5>

      <form onSubmit={submit}>
        {/* ASSET */}
        <div className="mb-3">
          <label className="form-label">Asset</label>
          <Select
            options={(assetList || []).map((a) => ({
              label: `[${a.company_asset_code}] ${a.name || ""}`,
              value: a.assets_id,
            }))}
            value={(assetList || [])
              .map((a) => ({
                label: `[${a.company_asset_code}] ${a.name || ""}`,
                value: a.assets_id,
              }))
              .find((o) => o.value === form.asset_id) || null}
            onChange={(opt) =>
              handleChange("asset_id", opt ? opt.value : "")
            }
            placeholder="Select Asset..."
            classNamePrefix="react-select"
          />
        </div>

        {/* STATUS */}
        <div className="mb-3">
          <label className="form-label">Status</label>
          <select
            className="form-control"
            value={form.status_id}
            onChange={(e) =>
              handleChange("status_id", e.target.value)
            }
          >
            {statusList.map((s) => (
              <option key={s.status_id} value={s.status_id}>
                {s.status_title}
              </option>
            ))}
          </select>
        </div>

        {/* RESOLUTION */}
        <div className="mb-3">
          <label className="form-label">Resolution</label>
          <select
            className="form-control"
            value={form.resolution_id}
            onChange={(e) =>
              handleChange("resolution_id", e.target.value)
            }
          >
            {resolutionList.map((r) => (
              <option key={r.res_id} value={r.res_id}>
                {r.res_title}
              </option>
            ))}
          </select>
        </div>

        {/* REMARKS */}
        <div className="mb-3">
          <label className="form-label">Remarks</label>
          <textarea
            className="form-control required-input"
            rows={3}
            value={form.remarks}
            onChange={(e) =>
              handleChange("remarks", e.target.value)
            }
          />
        </div>

<button
  className="btn btn-danger"
  style={{ backgroundColor: "#dc3545" }}
>
  Save
</button>
      </form>
    </div>
  );
};

export default TicketStatusUpdate;
